import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import './App.css';
import Home from './components/Home';
import Rules from './components/Rules';
import New from './components/New';
// import { ReachComponent as AddIcon } from '';

function App() {
  const [activePage, setActivePage] = useState('home');
  const [showNew, setShowNew] = useState(false);
  const [recordToEdit, setRecordToEdit] = useState(null);
  const [records, setRecords] = useState([]);
  const [mounted, setMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  const addRecord = (newRecord) => {
    setRecords(prevRecords => {
      // Create a copy of the previous records object
      const updatedRecords = { ...prevRecords };
      
      // If this person doesn't have any records yet, initialize with empty array
      if (!updatedRecords[newRecord.name]) {
        updatedRecords[newRecord.name] = [];
      }
      
      // Remove any existing record with the same date and name
      updatedRecords[newRecord.name] = updatedRecords[newRecord.name]
        .filter(record => record.date !== newRecord.date);
      
      // Add new record to this person's array and sort by date
      updatedRecords[newRecord.name] = [...updatedRecords[newRecord.name], newRecord]
        .sort((a, b) => new Date(b.date) - new Date(a.date));
      
      return updatedRecords;
    });
  };

  const handleEdit = (record) => {
    setRecordToEdit(record);
    setShowNew(true);
  };

  useEffect(() => {
    if (mounted) {
      return;
    }
    setMounted(true);
    const fetchRecords = async () => {
      try {
        const response = await fetch('https://prryj10q5a.execute-api.us-east-1.amazonaws.com/api/get-records');
        const data = await response.json();
        console.log(data);
        setRecords(data.records);
      } finally {
        setIsLoading(false);
      }
    };
    fetchRecords();
  }, []);

  // const runMath = () => {
  //   // Define the date range
  //   const startDate = new Date('2025-03-20');
  //   const endDate = new Date('2025-04-13');
    
  //   // Initialize results object
  //   const results = {};
    
  //   // Initialize totals for all people combined
  //   const overallTotals = {
  //     supplements: 0,
  //     eating: 0,
  //     walking: 0,
  //     workingOut: 0,
  //     running: 0,
  //     hydration: 0,
  //     alcohol: 0,
  //     bonus: 0,
  //     recordCount: 0
  //   };
    
  //   // Process each person's records
  //   Object.keys(records).forEach(person => {
  //     // Filter records within the date range
  //     const relevantRecords = records[person].filter(record => {
  //       const recordDate = new Date(record.date);
  //       return recordDate >= startDate && recordDate <= endDate;
  //     });
      
  //     // Skip if no records in the date range
  //     if (relevantRecords.length === 0) return;
      
  //     // Calculate total scores for each category
  //     const totals = {
  //       supplements: 0,
  //       eating: 0,
  //       walking: 0,
  //       workingOut: 0,
  //       running: 0,
  //       hydration: 0,
  //       alcohol: 0,
  //       bonus: 0,
  //       recordCount: relevantRecords.length
  //     };
      
  //     // Sum up all scores
  //     relevantRecords.forEach(record => {
  //       totals.supplements += record.supplements || 0;
  //       totals.eating += record.eating || 0;
  //       totals.walking += record.walking || 0;
  //       totals.workingOut += record.workingOut || 0;
  //       totals.running += record.running || 0;
  //       totals.hydration += record.hydration || 0;
  //       totals.alcohol += record.alcohol || 0;
  //       totals.bonus += record.bonus || 0;
  //     });
      
  //     // Add to overall totals
  //     overallTotals.supplements += totals.supplements;
  //     overallTotals.eating += totals.eating;
  //     overallTotals.walking += totals.walking;
  //     overallTotals.workingOut += totals.workingOut;
  //     overallTotals.running += totals.running;
  //     overallTotals.hydration += totals.hydration;
  //     overallTotals.alcohol += totals.alcohol;
  //     overallTotals.bonus += totals.bonus;
  //     overallTotals.recordCount += totals.recordCount;
      
  //     // Calculate averages
  //     const averages = {
  //       supplements: totals.supplements / totals.recordCount,
  //       eating: totals.eating / totals.recordCount,
  //       walking: totals.walking / totals.recordCount,
  //       workingOut: totals.workingOut / totals.recordCount,
  //       running: totals.running / totals.recordCount,
  //       hydration: totals.hydration / totals.recordCount,
  //       alcohol: totals.alcohol / totals.recordCount,
  //       bonus: totals.bonus / totals.recordCount,
  //       // Calculate overall average (sum of all categories divided by number of categories)
  //       overall: (
  //         totals.supplements + 
  //         totals.eating + 
  //         totals.walking + 
  //         totals.workingOut + 
  //         totals.running + 
  //         totals.hydration + 
  //         totals.alcohol + 
  //         totals.bonus
  //       ) / (8 * totals.recordCount)
  //     };
      
  //     results[person] = {
  //       averages,
  //       recordCount: totals.recordCount
  //     };
  //   });
    
  //   // Calculate overall averages across all people
  //   if (overallTotals.recordCount > 0) {
  //     results.overall = {
  //       averages: {
  //         supplements: overallTotals.supplements / overallTotals.recordCount,
  //         eating: overallTotals.eating / overallTotals.recordCount,
  //         walking: overallTotals.walking / overallTotals.recordCount,
  //         workingOut: overallTotals.workingOut / overallTotals.recordCount,
  //         running: overallTotals.running / overallTotals.recordCount,
  //         hydration: overallTotals.hydration / overallTotals.recordCount,
  //         alcohol: overallTotals.alcohol / overallTotals.recordCount,
  //         bonus: overallTotals.bonus / overallTotals.recordCount,
  //         overall: (
  //           overallTotals.supplements + 
  //           overallTotals.eating + 
  //           overallTotals.walking + 
  //           overallTotals.workingOut + 
  //           overallTotals.running + 
  //           overallTotals.hydration + 
  //           overallTotals.alcohol + 
  //           overallTotals.bonus
  //         ) / (8 * overallTotals.recordCount)
  //       },
  //       recordCount: overallTotals.recordCount
  //     };
  //   }
    
  //   console.log('Average scores between Mar 20 and Apr 13:', results);
  //   return results;
  // };

  // const addMissingRecords = async () => {
  //   // Get the average scores first
  //   const averageScores = runMath();
    
  //   if (!averageScores || !averageScores.overall) {
  //     console.error("Cannot add missing records: overall averages not available");
  //     return;
  //   }
    
  //   const startDate = new Date('2025-04-06');
  //   const endDate = new Date('2025-04-13');
  //   const peopleToFill = ["Evan"];
    
  //   // For each person
  //   for (const person of peopleToFill) {
  //     const existingDates = new Set();
      
  //     // Get their existing records in the date range
  //     if (records[person]) {
  //       records[person].forEach(record => {
  //         const recordDate = new Date(record.date);
  //         if (recordDate >= startDate && recordDate <= endDate) {
  //           existingDates.add(record.date);
  //         }
  //       });
  //     }
      
  //     // Generate all dates in the range
  //     const allDates = [];
  //     const currentDate = new Date(startDate);
  //     while (currentDate <= endDate) {
  //       const dateString = currentDate.toLocaleDateString('en-US', {
  //         month: '2-digit',
  //         day: '2-digit',
  //         year: 'numeric'
  //       });
  //       allDates.push(dateString);
  //       currentDate.setDate(currentDate.getDate() + 1);
  //     }
      
  //     // Find missing dates
  //     const missingDates = allDates.filter(date => !existingDates.has(date));
      
  //     // Create records for missing dates
  //     for (const date of missingDates) {
  //       const newRecord = {
  //         name: person,
  //         date: date,
  //         supplements: Math.round(averageScores.overall.averages.supplements),
  //         eating: Math.round(averageScores.overall.averages.eating),
  //         walking: Math.round(averageScores.overall.averages.walking),
  //         workingOut: Math.round(averageScores.overall.averages.workingOut),
  //         running: Math.round(averageScores.overall.averages.running),
  //         hydration: Math.round(averageScores.overall.averages.hydration),
  //         alcohol: Math.round(averageScores.overall.averages.alcohol),
  //         bonus: Math.round(averageScores.overall.averages.bonus),
  //         meditation: Math.round(averageScores.overall.averages.meditation || 5), // Default to 5 if not available
  //         autoFilled: true // Mark as automatically filled
  //       };
        
  //       try {
  //         // Send to API
  //         const response = await fetch('https://prryj10q5a.execute-api.us-east-1.amazonaws.com/api/add-record', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json'
  //           },
  //           body: JSON.stringify(newRecord)
  //         });
          
  //         if (response.ok) {
  //           console.log(`Added record for ${person} on ${date}`);
  //           // Update local state
  //           addRecord(newRecord);
  //         } else {
  //           console.error(`Failed to add record for ${person} on ${date}`);
  //         }
  //       } catch (error) {
  //         console.error(`Error adding record for ${person} on ${date}:`, error);
  //       }
        
  //       // Add a small delay to avoid overwhelming the API
  //       await new Promise(resolve => setTimeout(resolve, 300));
  //     }
  //   }
    
  //   console.log("Finished adding missing records");
  // };

  return (
    <div className="app">
      <div className='app-content'>
        {isLoading ? (
          <div className="loader">Loading...</div>
        ) : (
          <>
            {activePage === 'home' && <Home records={records} onEdit={handleEdit} />}
            {activePage === 'rules' && <Rules />}
            {showNew && (
              <New 
                onClose={() => {
                  setShowNew(false);
                  setRecordToEdit(null);
                }} 
                onAddRecord={addRecord}
                initialData={recordToEdit}
              />
            )}
          </>
        )}
      </div>
      <div className='app-footer'>
        <div 
          className={`app-footer-item ${activePage === 'home' ? 'active' : ''}`}
          onClick={() => setActivePage('home')}
        >
          <h3>Home</h3>
        </div>
        <div 
          className={`app-footer-item ${activePage === 'rules' ? 'active' : ''}`}
          onClick={() => setActivePage('rules')}
        >
          <h3>Rules</h3>
        </div>
        <div 
          className={`app-footer-item new ${showNew ? 'active' : ''}`}
          onClick={() => setShowNew(!showNew)}
        >
          <h3>+</h3>
        </div>
      </div>
    </div>
  );
}

export default App;
